// extracted by mini-css-extract-plugin
module.exports = {"generalLoaderWrapper":"styles_generalLoaderWrapper__3MD9a","loaderImage":"styles_loaderImage__13Aoz","loader":"styles_loader__1fRnz","load":"styles_load__224_o"};